import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Anulowane: {{reason}}',
    fulfilled: 'To zamówienie zostało pomyślnie zrealizowane',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Nie zaakceptowane',
    [OrderRejectionReason.ClosingSoon]: 'Wkrótce zamknięte',
    [OrderRejectionReason.ItemUnavailable]: 'Produkt niedostępny',
    [OrderRejectionReason.OrderTooBig]: 'Zamówienie zbyt duże',
    [OrderRejectionReason.CustomerMistake]: 'Błąd klienta',
    [OrderRejectionReason.Other]: 'Inne',
    fully_refunded: 'Zamówienie zostało w pełni zwrócone',
  },
};
